export default __webpack_public_path__ + "static/media/botoes_genericos_06.3fa5bcc1.mp3";